/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ApiPermission, V1PermissionsListError } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Permission<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Permission
   * @name V1PermissionsList
   * @request GET:/api/v1/permissions
   * @secure
   * @response `200` `(ApiPermission)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1PermissionsList = (params: RequestParams = {}) =>
    this.http.request<ApiPermission[], V1PermissionsListError>({
      path: `/api/v1/permissions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
